import { buildDynamicValidations, applyFlatValidators, buildFlatFormSchema, createForm, } from "@modyra/core";
export { buildFlatFormSchema as buildFormSchema };
/** Applies the Contract validators, under this renderer's own key. */
export function applyFieldValidators(form, fields) {
    applyFlatValidators(form, fields, "mdy-plain");
}
/** Builds and activates a real form from a flat field list, sharing one reactivity graph with every field's widget controller. Caller owns disposal via `form.deactivate()`. */
export function buildForm(fields, reactivity, collections = [], 
/**
 * What the form itself is asked to do beyond holding the fields — persistence, for now.
 *
 * Passed through rather than re-declared: a draft is the *form's* option, and this renderer's job
 * is to hand it over, not to have an opinion about it.
 */
formOptions = {}) {
    const { validations = [], fieldOptions, ...forwarded } = formOptions;
    const schema = buildFlatFormSchema(fields, collections);
    if (fieldOptions) {
        for (const [name, extra] of Object.entries(fieldOptions)) {
            const descriptor = schema[name];
            if (descriptor === undefined) {
                // Named a field the document does not have: a check attached to nothing is a guarantee the
                // host believes is in force, which is worse than no check at all.
                throw new TypeError(`fieldOptions names "${name}", which this document does not declare. `
                    + `It has: ${Object.keys(schema).join(", ")}`);
            }
            schema[name] = { ...descriptor, ...extra };
        }
    }
    const form = createForm(schema, {
        ...forwarded,
        validators: buildDynamicValidations(validations),
        reactivity,
        autoActivate: false,
    });
    applyFieldValidators(form, fields);
    form.activate();
    return form;
}
